import {getBreakpointsArray} from "./breakpoints";


let breakpoints = getBreakpointsArray()
let loadedScreenWidth = $( window ).width()
let loadedBreakpoint = getBreakpointForScreenSize(loadedScreenWidth)


function getBreakpointForScreenSize(screenSize){
  let breakpoint = ''
  $.each(breakpoints, function (i, el){
    if (i === 'screenW') return false;
    if (screenSize > el) breakpoint = i
  })

  return breakpoint
}

export function reloadIfScreenSizeInOtherBreakpoint(){
  let newBreakpoint = getBreakpointForScreenSize($( window ).width())

  if (loadedBreakpoint !== newBreakpoint) location.reload();
}

